/* Built In Imports */
import React, { useContext, useEffect, useRef, useState } from 'react';

/* External Imports */
import { Box, Image, Link, Text, useDisclosure } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import HeadComponent from '@components/Utility/HeadComponent';
import { refineUrlDomain } from '@components/Utility/utils';
import config from '@config';
import { AuthContext } from '@store/auth-context';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import {
  fetchFooterData,
  fetchHeaderMenuData,
  fetchHeaderTopMenuData,
} from 'services/commonService';
import {
  fetchExclusiveRenewPageData,
  getExclusiveLandingPaths,
} from 'services/exclusiveService';

/* Styles */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Sadhguru Exclusive Renew Page Data
 * @returns
 */

/**
 * @param {string} region - Current User Region
 * @param {string} language - Current User Language
 * @param {string} pageData - Sadhguru Exclusive Renew Page Data
 * @returns
 */

/**
 *
 * @param root0
 * @param root0.headerMenuData
 * @param root0.region
 * @param root0.language
 * @param root0.footerData
 * @param root0.pageData
 */
export default function Page({
  headerMenuData,
  region,
  language,
  footerData,
  pageData,
}) {
  const [currentUserRegion, setCurrentUserRegion] = useState(region);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [arrowToggle, setArrowToggle] = useState(false);
  const [PackageData, setPackageData] = useState([]);
  const [youtubeurl, setYoutubeurl] = useState('');
  const Banner = pageData => {
    const bannerDetail = pageData.body?.find(
      el => el.sectionId == 'HeaderBanner'
    );
    const bannerData = bannerDetail?.sectionContent;
    return (
      <>
        <Image
          src={bannerData[2]?.image.url}
          alt={bannerData[2]?.image.alt}
          title={bannerData[2]?.image.title}
          display={{ base: 'none !important', lg: 'block !important' }}
          w="100%"
        />
        <Image
          src={bannerData[2]?.mobileImage.url}
          alt={bannerData[2]?.mobileImage.alt}
          title={bannerData[2]?.mobileImage.title}
          display={{ base: 'block !important', lg: 'none !important' }}
          w="100%"
        />
        {/* exlusive main banner logo place holder*/}
        <Box
          background="#121212"
          padding={{ base: '25px', lg: '5px 200px 0px 200px' }}
          w={{ base: 'auto', lg: '1000px', '2xl': '1400px' }}
          position="relative"
          top={{ base: '9px', lg: '-140px' }}
          left={{
            base: '0',
            lg: 'calc((100% - 1000px) / 2)',
            '2xl': 'calc((100% - 1400px) / 2)',
          }}
          textAlign="center"
        >
          <Text
            color="#FFBD31"
            fontSize="18px"
            letterSpacing="2px"
            lineHeight="30px"
            textTransform="uppercase"
            margin="30px 0 10px 0"
          >
            {bannerData[0]?.titleSubtext}
          </Text>
          <h1>
            <Text
              color="#FFFFFF"
              fontSize={{ base: '22px', lg: '38px' }}
              lineHeight="1.29"
              fontFamily="FedraSansStd-A-medium"
              margin="0 0 20px 0"
            >
              {bannerData[0]?.titleText}
            </Text>
          </h1>
          <Text
            color="#d0caba"
            fontSize={{ lg: '14px', base: '16px' }}
            fontFamily="FedraSansStd-book"
          >
            {bannerData[1]?.text}
          </Text>
          {Renew(pageData)}
        </Box>
      </>
    );
  };
  const Renew = pageData => {
    const renewDetail = pageData.body?.find(el => el.sectionId == 'Renew');
    const renewData = renewDetail?.sectionContent;
    return (
      <>
        <Box>
          <Link
            w={{ base: '98%', lg: '368px' }}
            h="81px"
            m="20px auto"
            fontFamily="FedraSansStd-A-medium"
            fontSize="20px"
            lineHeight="81px"
            textAlign="center"
            display="block"
            background="#ffbd31"
            color="#121212"
            borderRadius="7px"
            className="buttonlink"
            // href={renewData[0]?.linkUrl}
            href={refineUrlDomain(renewData[0]?.linkUrl, region, language)}
            _hover={{ textDecor: 'none' }}
            cursor="pointer"
          >
            {renewData[0]?.buttonText}
          </Link>
        </Box>
      </>
    );
  };

  const authContext = useContext(AuthContext);
  const myRef = useRef(null);

  useEffect(() => {
    const currentRegion = config.locales.find(
      locale => locale.region_sf === region
    ).region;
    authContext.RegionAndLang(region, language);
    setCurrentUserRegion(currentRegion);
    const currentUrl = window.location.hash;
    if (currentUrl?.indexOf('#meet-sadhguru') >= 0) {
      myRef?.current?.scrollIntoView();
    }
  }, [authContext, region, language]);
  return (
    <>
      <HeadComponent
        data={pageData._seoMetaTags}
        availableLocals={pageData.availableLocales}
      ></HeadComponent>
      <Box m="0 auto" className="clear">
        <Box position="relative" background="#121212">
          <Box
            background="linear-gradient(to top, rgba(18, 18, 18, 0), rgba(18, 18, 18, 0.58) 100%"
            w="100%"
            h="20%"
            top="0"
            left="0"
            pos="absolute"
          ></Box>
          {Banner(pageData)}
          <Box
            background={`url('${config.imgPath}/d/46272/1644999728-footer-texture.jpg') repeat-x center`}
            min-height="150px"
            backgroundSize="100% 100%"
            p="0px 0 50px 0"
            textAlign="center"
          >
            <Image
              src={`${config.imgPath}/d/46272/1644999802-sgex-logo-new-white-2.svg`}
              alt="logo"
              title="logo"
            />
          </Box>
        </Box>
      </Box>
      <style global jsx>{`
        body {
          overflow-x: hidden;
        }
        .clear {
          clear: both;
        }
        .langopt-structure a {
          color: #cf4824;
        }
        .buttonlink:hover {
          text-decoration: none;
        }
        .loginlink p {
          color: #b0a999;
        }
        .loginlink a {
          border-bottom: 1px solid #ffbd31;
          color: #ffbd31;
        }
        .privacylink p {
          display: inline-block;
          whitespace: pre;
          padding: 40px 20px 0px 20px;
        }
        .privacylink p a {
          padding: 10px 30px;
          text-decoration: underline;
        }
        @media screen and (max-width: 768px) {
        }
      `}</style>
    </>
  );
}
export const getStaticPaths = async () => {
  let exclusiveRenewPath = config.USE_LOCAL_URL
    ? [`/in/en/sadhguru-exclusive/renew`]
    : await getExclusiveLandingPaths('L1', '/sadhguru-exclusive/renew');

  if (
    exclusiveRenewPath?.length < 1 &&
    config.BUILD_URLS?.LANDING_PAGES?.SadhguruExclusiveRenew
  ) {
    const pageData = await fetchExclusiveRenewPageData();
    exclusiveRenewPath = pageData?.availableLocales
      ? pageData?.availableLocales.map(locale => {
          return encodeURI(locale.value);
        })
      : [];
  }
  return {
    paths: exclusiveRenewPath,
    fallback: false,
  };
};

export const getStaticProps = async ({ params: { region, language }, req }) => {
  const headerTopMenuData = await fetchHeaderTopMenuData(
    getLocale(region, language),
    'isotopmenu'
  );
  const headerMenuData = await fetchHeaderMenuData(
    getLocale(region, language),
    'isomainmenu'
  );
  const footerData = await fetchFooterData(
    getLocale(region, language),
    'isofooter'
  );
  const pageData = await fetchExclusiveRenewPageData(region, language);

  return {
    props: {
      headerTopMenuData: headerTopMenuData?.data || null,
      headerMenuData: headerMenuData?.data || null,
      region,
      language,
      footerData: footerData?.data || null,
      pageData: pageData || null,
      page: 'Exclusive',
    },
  };
};
